import merge from 'lodash/merge'

import Accordion from './Accordion'
import AccordionSummary from './AccordionSummary'
import Alert from './Alert'
import AlertTitle from './AlertTitle'
import AppBar from './AppBar'
import Backdrop from './Backdrop'
import Badge from './Badge'
import Button from './Button'
import ButtonBase from './ButtonBase'
import ButtonGroup from './ButtonGroup'
import Card from './Card'
import CardContent from './CardContent'
import Checkbox from './Checkbox'
import Chip from './Chip'
import Container from './Container'
import Dialog from './Dialog'
import DialogContentText from './DialogContentText'
import DialogTitle from './DialogTitle'
import Fab from './Fab'
import IconButton from './IconButton'
import InputBase from './InputBase'
import LinearProgress from './LinearProgress'
import Link from './Link'
import ListItemButton from './ListItemButton'
import ListItemIcon from './ListItemIcon'
import MenuItem from './MenuItem'
import OutlinedInput from './OutlinedInput'
import Pagination from './Pagination'
import PaginationItem from './PaginationItem'
import Paper from './Paper'
import Popover from './Popover'
import Radio from './Radio'
import Slider from './Slider'
import Switch from './Switch'
import Tab from './Tab'
import TableCell from './TableCell'
import TableHead from './TableHead'
import Tabs from './Tabs'
import ToggleButton from './ToggleButton'
import Tooltip from './Tooltip'
import TreeItem from './TreeItem'
import Typography from './Typography'

export default function ComponentsOverrides(theme) {
  return merge(
    Accordion(theme),
    AccordionSummary(theme),
    AppBar(theme),
    Alert(theme),
    AlertTitle(theme),
    Backdrop(theme),
    Badge(theme),
    Button(theme),
    ButtonBase(theme),
    ButtonGroup(theme),
    Card(theme),
    CardContent(theme),
    Checkbox(theme),
    Chip(theme),
    Container(theme),
    Dialog(theme),
    DialogContentText(theme),
    DialogTitle(theme),
    Fab(theme),
    IconButton(theme),
    InputBase(theme),
    LinearProgress(theme),
    Link(theme),
    ListItemButton(theme),
    ListItemIcon(theme),
    MenuItem(theme),
    OutlinedInput(theme),
    Pagination(theme),
    PaginationItem(theme),
    Paper(theme),
    Popover(theme),
    Radio(theme),
    Slider(theme),
    Switch(theme),
    Tab(theme),
    TableCell(theme),
    TableHead(theme),
    Tabs(theme),
    ToggleButton(theme),
    Tooltip(theme),
    TreeItem(theme),
    Typography(theme)
  )
}
